import React from "react";
import { cn } from "@/lib/utils";

interface FormSectionProps {
  id: string;
  title: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({ id, title, headerActions, children, className }: FormSectionProps) {
  return (
    <div
      id={id}
      className={cn(
        "scroll-mt-6 bg-white border border-slate-200/80 rounded-2xl p-6 md:p-8 shadow-sm flex flex-col gap-6",
        className
      )}
    >
      <div className="flex items-center justify-between select-none border-b border-slate-100 pb-4">
        <h3 className="text-lg font-bold text-slate-800 font-sans tracking-tight">{title}</h3>
        {headerActions}
      </div>

      <div className="pt-0">{children}</div>
    </div>
  );
}
